import { useAppContext } from "@context/app";
import AreaView from "@elements/areaView";
import useRequestImmutable from "@hooks/useRequestImmutable";
import Modal from "@modules/layout/modal";
import { IAreaDetailInput, IAreaInput } from "@types";
import { useIsMount } from "@utils/helpers";
import { commonApi } from "gate";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";

interface AreaFieldProps {
  area?: IAreaDetailInput;
  onChange?: (data: IAreaDetailInput) => void;
  placeholder?: string;
  optionalSubArea?: boolean
}

const AreaField: React.FC<AreaFieldProps> = ({ area, onChange, placeholder, optionalSubArea }) => {
  const t = useTranslations();
  const { locale } = useRouter();
  const isRTL = locale?.startsWith("ar") || false;
  const { country } = useAppContext();
  const isMount = useIsMount();
  const [areaList, setAreaList] = useState<IAreaInput[]>([]);
  const [openAreaView, setOpenAreaView] = useState<boolean>(false);
  const [selectedArea, setSelectedArea] = useState<IAreaDetailInput | undefined>(area);

  const { data: areas } = useRequestImmutable(
    country ? commonApi.getAreaList(country.id) : undefined
  );

  useEffect(() => {
    if (areas) {
      setAreaList(areas.data.items);
    }
  }, [areas]);

  useEffect(() => {
    setSelectedArea(area);
  }, [area]);

  let areaText = "";
  if (selectedArea) {
    if (selectedArea.parentName) {
      areaText += selectedArea.parentName + ",";
    }
    if (selectedArea.name) {
      areaText += " " + selectedArea.name;
    }
  }

  return (
    <div className="md:w-full sm:w-full xs:w-full w-full p-1">
      <Modal
        open={openAreaView}
        onClose={() => setOpenAreaView(false)}
        cancelable
        withoutBackground
      >
        <div className="md:w-full sm:w-[calc(100vw-8px)] xs:w-[calc(100vw-8px)] w-[calc(100vw-8px)] max-w-[850px] min-h-[480px] h-[max-content] bg-white rounded-lg p-3 mx-auto">
          <div className=" sm:min-w-[420px] xs:min-w-full min-w-full">
            <div className=" w-full flex flex-wrap mb-5 items-center">
              <p className="w-10 text-[#999]"></p>
              <p className="flex-1 font-normal text-xl text-[#333] text-center">
                {t("client_area_selectarea")}
              </p>
              <p className="w-10 text-[#999] flex justify-end">
                <BsX size={24} className=" cursor-pointer" onClick={() => setOpenAreaView(false)} />
              </p>
            </div>
            <div className="w-full  rounded-xl  overflow-auto overflow-x-hidden h-[430px] ">
              <AreaView
                areas={areaList}
                action={(a) => {
                  setSelectedArea(a);
                  onChange?.(a);
                  setOpenAreaView(false);
                }}
                optionalSubArea={optionalSubArea}
              />
            </div>
          </div>
        </div>
      </Modal>
      <div
        className={`form__group w-full h-14 bg-[#F5F5F5] rounded-xl relative flex items-center px-2 ${
          isRTL ? "flex-row-reverse" : ""
        }`}
      >
        <div className="w-6 h-6 rounded-full overflow-hidden border mr-1 relative">
          <Image src={country?.image.url || ""} alt="" layout="fill" />
        </div>
        <div className={`flex-1 px-2 ${isRTL ? "text-right" : "text-left"}`}>
          <p
            className={`text-sm font-normal ${areaText ? "text-[#333]" : "text-[#999]"} ${
              isRTL ? "text-right" : "text-left"
            }`}
          >
            {areaText || placeholder || t("client_area_selectarea")}
          </p>
        </div>
        <div className="w-6">
          <button type="button" onClick={() => setOpenAreaView(true)} className=" text-[#999]">
            <BiPencil size={22} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AreaField;
